export default __webpack_public_path__ + "static/media/graphic-14.08a95e0f.png";